import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../components/modal";
import RageSelector from "../../components/rangeSlider";
import { DropDownInput } from "../../wrappers/selectInput";
import Button from "../../components/button";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import { skillNameConverter } from "../../utils/EllowUtils";


export type resourceFilterFormFields = {
  jobRole: any;
  core_skills: any;
  coreSkillsCombination: any;
  experience: any;
}

interface props {
  onClose?: any;
  ClickHandler?: any;
  defaultValues?: any;
  skillsList: any;
}

const ResourceFilter: React.FC<props> = ({
  onClose,
  ClickHandler,
  defaultValues,
  skillsList
}) => {

  const formOptions = {    defaultValues: useMemo(() => { return defaultValues }, [defaultValues])};

  const skillvalues = skillsList && skillsList.length > 0 && skillNameConverter(skillsList) &&  skillNameConverter(skillsList).length > 0 &&  skillNameConverter(skillsList).map((item: any) => item.skillName);
  const [range, setRange] = useState<{ from?: number; to?: number }>({ from: 0, to: 20 })
  
  useEffect(() => {
    if (defaultValues && defaultValues.experience) {
      setRange(defaultValues.experience);
      setValue('experience', defaultValues.experience)
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);


  const { register, handleSubmit, control, setValue } = useForm<resourceFilterFormFields>(formOptions);

  const onSubmit = (data: any) => {
    ClickHandler(data) 
  }

  const rangeChange = (startValue: any, endValue: any) => {
    let range = {
      from: startValue,
      to: endValue,
    }
    setValue("experience", range);
    setRange(range);
  }

  return (
    <Modal title={" "} size="medium" onClose={onClose}>
      <form>
        <div className="form-group">
          <label className="lablel">Core Skills</label>
          <MultiDropDownInput<resourceFilterFormFields>
            name="core_skills"
            placeholder=""
            data={skillvalues}
            register={register}
            control={control}
            allowCustom={false}
          />
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Skills combination</label>
            <DropDownInput<resourceFilterFormFields>
              name='coreSkillsCombination'
              data={[{ name: 'AND', id: true }, { name: 'OR', id: false }]}
              register={register}
              control={control}
              dataItemKey='id'
              textField="name"
            />
          </div>
         
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">
             Experience Range &nbsp;
              <strong>
                {range.from} - {range.to}
              </strong>
            </label>
            <RageSelector
              defaultValue={defaultValues && defaultValues.experience && {min: defaultValues.experience.from, max: defaultValues.experience.to}}
              onChange={(e: any) =>
                rangeChange(Math.floor(e.value.start), Math.floor(e.value.end))
              }
            />
          </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit(onSubmit)}>
            Apply Filter
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default ResourceFilter;
